import React from 'react';
import { Form } from 'react-bootstrap';

/**
 * Controlled search input used on the streaming event pages
 * (NFL, Motorsports, Live TV) to filter the displayed events.
 *
 * @param {object} props
 * @param {string} props.value - The current search query.
 * @param {Function} props.onChange - Called with the next query string.
 */
function EventSearchBox({ value, onChange }) {
    return (
        <Form.Control
            type="search"
            className="mb-3"
            placeholder="Search events..."
            aria-label="Search events"
            value={value}
            onChange={(event) => onChange(event.target.value)}
        />
    );
}

export default EventSearchBox;
